import styled from 'styled-components'

export const LinkCustom = styled.span`
  cursor: pointer;
  color: #007BFF;
  font-weight: 600;
`